import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Input,
  Button,
  Alert,
  message,
} from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { adminLogin } from '../../../modules/auth';
import './adminLoginPage.css';

const renderAdminBrand = () => (
  <>
    SO<span className="admin-login__brand-accent">A</span>L
    <span className="admin-login__brand-accent">I</span>VE
  </>
);

class AdminLoginPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      errorMessage: null,
      disableSubmit: true,
    };

    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.updateSubmitDisabled();
  }

  updateSubmitDisabled = () => {
    const form = this.formRef && this.formRef.current;
    if (!form) {
      return;
    }

    const requiredFields = ['email', 'password'];
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
    const values = form.getFieldsValue(requiredFields);
    const hasEmptyRequired = requiredFields.some((field) => {
      const value = values[field];
      return value === undefined || value === null || value === '';
    });

    const shouldDisable = hasErrors || hasEmptyRequired;
    if (this.state.disableSubmit !== shouldDisable) {
      this.setState({ disableSubmit: shouldDisable });
    }
  };

  handleFieldsChange = () => {
    this.updateSubmitDisabled();
  };

  handleSubmit = async (values) => {
    this.setState({
      loading: true,
      errorMessage: null,
    });

    const { adminLogin: loginAsAdmin, history } = this.props;
    try {
      await loginAsAdmin({
        email: values.email.trim().toLowerCase(),
        password: values.password,
      });
      message.success('Admin login successful.');
      history.replace('/admin');
    } catch (error) {
      const messageText = (error
        && error.response
        && error.response.data
        && error.response.data.message)
        ? error.response.data.message
        : 'Failed to login as admin.';
      this.setState({ errorMessage: messageText });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { loading, errorMessage, disableSubmit } = this.state;

    return (
      <div className="admin-login">
        <div className="admin-login__card">
          <div className="admin-login__hero">
            <div className="admin-login__logo">{renderAdminBrand()}</div>
            <h2>Admin Console Access</h2>
            <p>
              Sign in with your admin credentials to manage users, credit plans, and content policies.
            </p>
          </div>
          <div className="admin-login__panel">
            <h1>Admin Login</h1>
            {errorMessage && (
              <Alert
                type="error"
                message={errorMessage}
                showIcon
                style={{ marginBottom: 16 }}
              />
            )}
            <Form
              layout="vertical"
              onFinish={this.handleSubmit}
              requiredMark={false}
              ref={this.formRef}
              onFieldsChange={this.handleFieldsChange}
            >
              <Form.Item
                name="email"
                label="Admin email"
                rules={[
                  { required: true, message: 'Email is required' },
                  { type: 'email', message: 'Enter a valid email' },
                ]}
              >
                <Input placeholder="admin@example.com" size="large" />
              </Form.Item>
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  { required: true, message: 'Password is required' },
                ]}
              >
                <Input.Password placeholder="Password" size="large" />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  block
                  loading={loading}
                  disabled={disableSubmit}
                >
                  Log in
                </Button>
              </Form.Item>
            </Form>
            <div className="admin-login__footer">
              <a href="/" className="admin-login__link">Back to user portal</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AdminLoginPage.propTypes = {
  adminLogin: PropTypes.func.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
};

const mapDispatchToProps = {
  adminLogin,
};

export default withRouter(connect(null, mapDispatchToProps)(AdminLoginPage));
